import {
  NormalBrowseFileInputFiled,
  NormalMultipleFixedInputFields,
  NormalTextInputField,
} from "@/components";
import React, { useMemo } from "react";

const FujairahPartnersCMSForm = ({
  activeTab,
  isFetching,
  formData,
  selectedTab,
  allFilesResponse,
  searchValue,
  selectedFileType,
  handleTextInputChange,
  handleTextEditorInputChange,
  handleImageChange,
  adminRole,
  permissionsList,
}) => {
  const isHideInOtherLanguages = useMemo(() => {
    return activeTab === "en" ? true : false;
  }, [activeTab]);

  return (
    <>
      {selectedTab === "section-1" && (
        <>
          {/* Banner Image */}
          {isHideInOtherLanguages && (
            <NormalBrowseFileInputFiled
              isFetching={isFetching}
              labelText="Banner Image"
              fieldId="partner-banner-image"
              allFilesResponse={allFilesResponse}
              searchValue={searchValue}
              selectedFileType={selectedFileType}
              onChangeImageFunction={(id) =>
                id
                  ? handleImageChange("partner-banner-image", id)
                  : handleImageChange("partner-banner-image", "")
              }
              selectedFileId={formData?.["partner-banner-image"] || ""}
              adminRole={adminRole}
              permissionsList={permissionsList}
              infoText="Recommended size: 1300 x 650px"
            />
          )}

          {/* Banner Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Banner Heading"
            fieldId="partner-banner-heading"
            fieldName="partner-banner-heading"
            placeholderText="Banner Heading"
            inputValue={formData?.["partner-banner-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Banner Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Banner Description"
            fieldId="partner-banner-description"
            fieldName="partner-banner-description"
            placeholderText="Banner Description"
            inputValue={formData?.["partner-banner-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />
        </>
      )}

      {selectedTab === "section-2" && (
        <>
          {/* Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Info Heading"
            fieldId="partner-info-heading"
            fieldName="partner-info-heading"
            placeholderText="Info Heading"
            inputValue={formData?.["partner-info-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
          />

          {/* Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Info Description"
            fieldId="partner-info-description"
            fieldName="partner-info-description"
            placeholderText="Info Description"
            inputValue={formData?.["partner-info-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Info Cards */}
          <NormalMultipleFixedInputFields
            stateDetails={formData}
            isFetching={isFetching}
            labelText="Info Cards"
            fieldId="partners-info-cards"
            allFilesResponse={allFilesResponse}
            searchValue={searchValue}
            selectedFileType={selectedFileType}
            handleTextInputChange={handleTextInputChange}
            handleImageChange={handleImageChange}
            translateField={true}
            extraContainerClasses="mt-5"
            cards={[
              {
                card_id: "partners-info-card-1",
                types: ["IMAGE", "TEXT"],
                is_hidden: [isHideInOtherLanguages, true],
                ids_name: ["logo_field_id", "text_filed_id"],
                placeholders_name: ["", "text_filed_placeholder"],
                // IDs
                logo_field_id: "partners-info-card-logo-1",
                text_filed_id: "partners-info-card-name-1",
                // Placeholders
                text_filed_placeholder: "Name 1",
              },
              {
                card_id: "partners-info-card-2",
                types: ["IMAGE", "TEXT"],
                is_hidden: [isHideInOtherLanguages, true],
                ids_name: ["logo_field_id", "text_filed_id"],
                placeholders_name: ["", "text_filed_placeholder"],
                // IDs
                logo_field_id: "partners-info-card-logo-2",
                text_filed_id: "partners-info-card-name-2",
                // Placeholders
                text_filed_placeholder: "Name 2",
              },
              {
                card_id: "partners-info-card-3",
                types: ["IMAGE", "TEXT"],
                is_hidden: [isHideInOtherLanguages, true],
                ids_name: ["logo_field_id", "text_filed_id"],
                placeholders_name: ["", "text_filed_placeholder"],
                // IDs
                logo_field_id: "partners-info-card-logo-3",
                text_filed_id: "partners-info-card-name-3",
                // Placeholders
                text_filed_placeholder: "Name 3",
              },
            ]}
          />
        </>
      )}

      {selectedTab === "section-3" && (
        <>
          {/* Enquiry Options */}
          <NormalMultipleFixedInputFields
            stateDetails={formData}
            isFetching={isFetching}
            labelText="Enquiry Options"
            fieldId="enquiry-option-cards"
            handleTextInputChange={handleTextInputChange}
            handleTextEditorInputChange={handleTextEditorInputChange}
            translateField={true}
            cards={[
              {
                card_id: "enquiry-option-card-1",
                types: ["TEXT", "TEXT_EDITOR", "TEXT"],
                is_hidden: [true, true, true],
                ids_name: [
                  "text_filed_id_1",
                  "text_filed_id_2",
                  "text_filed_id_3",
                ],
                placeholders_name: [
                  "text_filed_placeholder_1",
                  "text_filed_placeholder_2",
                  "text_filed_placeholder_3",
                ],
                // IDs
                text_filed_id_1: "enquiry-option-card-category-1",
                text_filed_id_2: "enquiry-option-card-points-1",
                text_filed_id_3: "enquiry-option-card-button-label-1",
                // Placeholders
                text_filed_placeholder_1: "Category 1",
                text_filed_placeholder_2: "Key Points 1",
                text_filed_placeholder_3: "Button Label 1",
              },
              {
                card_id: "enquiry-option-card-2",
                types: ["TEXT", "TEXT_EDITOR", "TEXT"],
                is_hidden: [true, true, true],
                ids_name: [
                  "text_filed_id_1",
                  "text_filed_id_2",
                  "text_filed_id_3",
                ],
                placeholders_name: [
                  "text_filed_placeholder_1",
                  "text_filed_placeholder_2",
                  "text_filed_placeholder_3",
                ],
                // IDs
                text_filed_id_1: "enquiry-option-card-category-2",
                text_filed_id_2: "enquiry-option-card-points-2",
                text_filed_id_3: "enquiry-option-card-button-label-2",
                // Placeholders
                text_filed_placeholder_1: "Category 2",
                text_filed_placeholder_2: "Key Points 2",
                text_filed_placeholder_3: "Button Label 2",
              },
            ]}
          />

          {/* Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Enqiry Form Heading"
            fieldId="enquiry-form-heading"
            fieldName="enquiry-form-heading"
            placeholderText="Enqiry Form Heading"
            inputValue={formData?.["enquiry-form-heading"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Description */}
          <NormalTextInputField
            isFetching={isFetching}
            isTextArea={true}
            labelText="Enqiry Form Description"
            fieldId="enquiry-form-description"
            fieldName="enquiry-form-description"
            placeholderText="Enqiry Form Description"
            inputValue={formData?.["enquiry-form-description"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />

          {/* Heading */}
          <NormalTextInputField
            isFetching={isFetching}
            labelText="Form Button Label"
            fieldId="enquiry-form-button-label"
            fieldName="enquiry-form-button-label"
            placeholderText="Form Button Label"
            inputValue={formData?.["enquiry-form-button-label"] || ""}
            onChangeTextInputField={handleTextInputChange}
            translateField={true}
            extraContainerClasses="mt-5"
          />
        </>
      )}
    </>
  );
};

export default FujairahPartnersCMSForm;
